<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Verification Required
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      {{ body }}
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="navigate"
      >
        Got it
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationRequired',
  props: {
    toggleActionModal: Function,
    navigate: Function,
    body: String,
  },
};
</script>

<style lang="scss" scoped>

.ac-body-container {
  font-weight: 500;
}

.ac-form-button {
  background-color: $NBLUE100 !important;
  color: $WHITE !important;

  &:hover {
    background-color: $NBLUE90 !important;
  }
}
</style>
